import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// The track is the soft tint, in both schemes.
//
// This picked its slot by scheme on top of tokens that already invert, which
// is the same construct that made a dark-mode alert unreadable. Here it put
// `accentLightInk` behind the bar: a `#AFC6F5` pale lavender track carrying
// the `#3D6AE0` bar at 2.82:1, under the 3:1 a graphical object needs, with
// the polarity inverted so the bar read as a smudge inside a bright track.
// ----------------------------------------------------------------------

export default function Progress(theme: Theme) {
  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          overflow: 'hidden',
        },
        bar: {
          borderRadius: 4,
        },
        colorPrimary: {
          backgroundColor: theme.palette.grey[200],
        },
        buffer: {
          backgroundColor: 'transparent',
        },
      },
    },
  }
}
